export default __webpack_public_path__ + "static/media/icon-repeat-black.8150e97f.svg";